const defaultStepValue = '20';

const stepListDefault = [
    { label: '2', value: '50' },
    { label: '4', value: '25' },
    { label: '5', value: defaultStepValue },
    { label: '8', value: '12.5' },
    { label: '10', value: '10' },
];

const stepListMixer = [
    { label: '1', value: '50' },
    { label: '3', value: '25' },
    { label: '4', value: defaultStepValue },
    { label: '7', value: '12.5' },
    { label: '9', value: '10' },
];

export { defaultStepValue, stepListDefault, stepListMixer };
